import {
  INPUT_TYPE,
  validateRepeated,
  validateSpaceAndEnter,
} from '@components/dragableTableFrom/formItems';

import { FORM_KEYS } from './form.keys';

export const INPUT_MAP = {
  [FORM_KEYS.NAVI_NAME.key]: {
    inputType: INPUT_TYPE.INPUT,
    rules: [validateSpaceAndEnter(FORM_KEYS.NAVI_NAME.label)],
  },
  [FORM_KEYS.MODULE.key]: {
    inputType: INPUT_TYPE.INPUT,
    rules: [validateSpaceAndEnter(FORM_KEYS.MODULE.label)],
    maxLength: 40,
    placeholder: FORM_KEYS.MODULE.placeholder,
  },
  [FORM_KEYS.SECTION.key]: {
    inputType: INPUT_TYPE.INPUT,
    rules: [validateSpaceAndEnter(FORM_KEYS.SECTION.label)],
    maxLength: 40,
    placeholder: FORM_KEYS.SECTION.placeholder,
  },
  [FORM_KEYS.TYPE.key]: {
    inputType: INPUT_TYPE.PURE_TEXT,
  },
  [FORM_KEYS.DISPLAY.key]: {
    inputType: INPUT_TYPE.CHECK_BOX,
  },
  [FORM_KEYS.IFRAME.key]: {
    inputType: INPUT_TYPE.CHECK_BOX,
  },
  [FORM_KEYS.ORDER.key]: {
    inputType: INPUT_TYPE.NUMBER,
    rules: [
      {
        required: true,
        message: `${FORM_KEYS.ORDER.label} is required`,
      },
      validateRepeated(FORM_KEYS.ORDER.key),
    ],
  },
  [FORM_KEYS.COLOR.key]: { inputType: INPUT_TYPE.COLORSELECTOR },
  [FORM_KEYS.LINK.key]: {
    inputType: INPUT_TYPE.TEXT,
    placeholder: FORM_KEYS.LINK.placeholder,
  },
  [FORM_KEYS.DES.key]: {
    inputType: INPUT_TYPE.TEXT,
    maxLength: 180,
    placeholder: FORM_KEYS.DES.placeholder,
  },
  [FORM_KEYS.DELETE.key]: {
    inputType: INPUT_TYPE.DELETE,
  },
  [FORM_KEYS.DRAG.key]: {
    inputType: INPUT_TYPE.DRAG,
  },
  [FORM_KEYS.RATIO.key]: {
    inputType: INPUT_TYPE.PURE_SELECT,
    optionKey: FORM_KEYS.RATIO.key,
    // shouldUpdate: (prev, cur) => prev.iframe !== cur.iframe,
  },
  [FORM_KEYS.MultiType.key]: {
    inputType: INPUT_TYPE.PURE_TEXT,
    // inputType: INPUT_TYPE.PURE_SELECT,
    optionKey: FORM_KEYS.MultiType.key,
    // shouldUpdate: (prev, cur) => prev.iframe !== cur.iframe,
  },
};
